import CashCountFooter from './CashCountFooter';

interface CashAuditSummaryProps {
  countNumber?: string;
  expectedAmount: number;
  countedAmount: number;
  difference: number;
}

const CashAuditSummary: React.FC<CashAuditSummaryProps> = ({
  countNumber,
  expectedAmount,
  countedAmount,
  difference,
}) => {
  return (

    <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
      
      {/* HEADER */}
      <div className="border-b border-stroke px-6 py-4 dark:border-strokedark">

        <h3 className="font-medium text-black dark:text-white">
          Resultado del Arqueo
        </h3>

        {countNumber && (
          <p className="mt-1 font-mono text-xs text-gray-500">
            {countNumber}
          </p>
        )}

      </div>

      {/* FOOTER RESULT */}
      <CashCountFooter
        expectedAmount={expectedAmount}
        countedAmount={countedAmount}
        difference={difference}
      />

    </div>

  );
};

export default CashAuditSummary;